import { useState, useEffect } from 'react';

export type ScrollDirection = 'up' | 'down';

export function useScrollDirection() {
    const [scrollDirection, setScrollDirection] = useState<ScrollDirection>('up');
    const [isAtTop, setIsAtTop] = useState(true);

    useEffect(() => {
        let lastScrollY = window.scrollY;
        let ticking = false;

        const updateScrollDirection = () => {
            const scrollY = window.scrollY;

            // Check if we're at the top
            setIsAtTop(scrollY < 10);

            // Determine scroll direction
            if (Math.abs(scrollY - lastScrollY) < 5) {
                // Ignore small movements
                ticking = false;
                return;
            }

            setScrollDirection(scrollY > lastScrollY ? 'down' : 'up');
            lastScrollY = scrollY > 0 ? scrollY : 0;
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDirection);
                ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll);

        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return { scrollDirection, isAtTop };
}
